<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <div>
                Tipo Actividad<select class="form-control" v-model="configuration.TIPO_ACTIVIDAD">
                  <option value="1">1. Asociar número y cantidad</option>
                  <option value="2">2. Leer y escribir cantidades</option>
                  <option value="3">3. Escribir en forma de número mixto el representado en una fracción</option>
                  <option value="4">4. Escribir un número mixto en forma de fracción</option>
                </select>
              </div>
              <br>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                  id="INDICATIVO_UNIDAD" v-model="configuration.INDICATIVO_UNIDAD">
                <label class="custom-control-label" for="INDICATIVO_UNIDAD">Indicativo Unidad</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.AUDIO_POR_ACTIVIDAD"
                id="AUDIO_POR_ACTIVIDAD">
                <label class="custom-control-label" for="AUDIO_POR_ACTIVIDAD">Audio por actividad</label>
              </div>
          </div>
            <div class="col-md-4">
            <div class="mb-2 font-weight-bold">Representaciones</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.ARABIGO"
                id="ARABIGO">
                <label class="custom-control-label" for="ARABIGO">Arábigo</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ESCRITO"
                id="VERBAL_ESCRITO">
                <label class="custom-control-label" for="VERBAL_ESCRITO">Verbal escrito</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                  id="REPRESENTACION_GRAFICA" v-model="configuration.REPRESENTACION_GRAFICA">
                <label class="custom-control-label" for="REPRESENTACION_GRAFICA">Representación Gráfica</label>
              </div>
              <!--<br/>
                  Tipo Representación<select class="form-control" v-model="configuration.TIPO_REPRESENTACION">
                    <option value="0">Forma Geométrica</option>
                    <--<option value="1">Dos imágenes</option>--
                    <--<option value="2">Ilustraciones</option>--
                  </select>
              <br>
                  Forma de Representación<select class="form-control" v-model="configuration.FORMA_REPRESENTACION">
                    <option value="0">Círculo</option>
                    <--<option value="1">Varias filas</option>--
                    <--<option value="2">1 Fila</option>--
                  </select>
              <br>
                  Orden Representación<select class="form-control" v-model="configuration.ORDEN_REPRESENTACION">
                    <option value="0">Continuo </option>
                    <--<option value="1">Discontinuo</option>--
                  </select>-->
              <br>
            </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Respuestas</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                id="resarabigo" disabled checked>
                <label class="custom-control-label" for="resarabigo">
                  Respuesta Arábigo</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ORAL"
                id="respverbaloral">
                <label class="custom-control-label" for="respverbaloral">
                  Respuesta Verbal Oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ESCRITO"
                id="RESP_VERBAL_ESCRITO">
                <label class="custom-control-label" for="RESP_VERBAL_ESCRITO">Respuesta Verbal Escrita</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_REPRESENTACION_GRAFICA"
                id="RESP_REPRESENTACION_GRAFICA">
                <label class="custom-control-label" for="RESP_REPRESENTACION_GRAFICA">Respuesta Representación Gráfica</label>
              </div>
              <!--<br/>
                  Respuesta Tipo Representación<select class="form-control" v-model="configuration.RESP_TIPO_REPRESENTACION">
                    <option value="0">Círculo</option>
                    <--<option value="1">Dos imágenes</option>--
                    <--<option value="2">Ilustración</option>--
                  </select>
              <br>
                  Resp. Forma de Representación<select class="form-control" v-model="configuration.RESP_FORMA_REPRESENTACION">
                    <option value="0">Círculo</option>
                    <--<option value="1">Varias filas</option>--
                    <--<option value="2">Una fila</option>--
                  </select>
              <br>
                  Resp. Orden Representación<select class="form-control" v-model="configuration.RESP_ORDEN_REPRESENTACION">
                    <option value="0">Continuo </option>
                    <--<option value="1">Discontinuo</option>--
                  </select>-->
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row  class="justify-content-md-center">
          <b-col col lg="3" style="text-align:center"><h6>Entero</h6></b-col>
          <b-col col lg="1" style="text-align:center"></b-col>
          <b-col col lg="3" style="text-align:center"><h6>Numerador</h6></b-col>
          <b-col col lg="1" style="text-align:center"></b-col>
          <b-col col lg="3" style="text-align:center"><h6>Denominador</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="3">
                <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                  <b-form-input type="number"
                      v-bind:id="'ENTERO' + index"
                      v-model="arrayEleOperation[index].ENTERO"/>
                      <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="1"  style="text-align:center"></b-col>
               <b-col col lg="3">
                 <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                  <b-form-input type="number"
                      v-bind:id="'NUMERADOR' + index"
                      v-model="arrayEleOperation[index].NUMERADOR"/>
                      <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
               <b-col col lg="1"  style="text-align:center">
                /
              </b-col>
              <b-col col lg="3">
                <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                  <b-form-input type="number"
                      v-bind:id="'DENOMINADOR' + index"
                      v-model="arrayEleOperation[index].DENOMINADOR"/>
                      <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('numeric', {
  ...numeric,
  message: 'Número positivo. Sin Decimales.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: -1,
        TIPO_ACTIVIDAD: 1,
        ARABIGO: true,
        VERBAL_ORAL: false,
        VERBAL_ESCRITO: true,
        REPRESENTACION_GRAFICA: true,
        TIPO_REPRESENTACION: 0,
        FORMA_REPRESENTACION: 0,
        ORDEN_REPRESENTACION: 0,
        RESP_VERBAL_ORAL: true,
        RESP_VERBAL_ESCRITO: true,
        RESP_REPRESENTACION_GRAFICA: true,
        RESP_TIPO_REPRESENTACION: 0, //
        RESP_FORMA_REPRESENTACION: 0, //
        RESP_ORDEN_REPRESENTACION: 0, //
        INDICATIVO_UNIDAD: false, //
        AUDIO_POR_ACTIVIDAD: false, //
        IMAGENES_ID_RESP_ILUST: 0,
        IMAGENES_ID_ILUST: 0,
        IMAGENES_ID_RESP_NUM: 0,
        IMAGENES_ID_NUM: 0,
        IMAGENES_ID_RESP_DEN: 0,
        IMAGENES_ID_DEN: 0,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        ENTERO: null,
        NUMERADOR: null,
        DENOMINADOR: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('mixednumeration/getmixednumeration', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            ENTERO: element.ENTERO,
            NUMERADOR: element.NUMERADOR,
            DENOMINADOR: element.DENOMINADOR,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
